export default __webpack_public_path__ + "static/media/f5.3c7d0538.svg";